import React, { Children } from 'react';
import { TrendingUpIcon, UsersIcon, DollarSignIcon, CheckCircleIcon } from 'lucide-react';
import { AnimatedMetric } from '../ui/AnimatedMetric';
import { motion } from 'framer-motion';
export function ResultsSummary() {
  const metrics = [{
    icon: UsersIcon,
    value: 4000,
    suffix: '+',
    label: 'Reps Hired with the HIRE Advantage system',
    sublabel: ''
  }, {
    icon: DollarSignIcon,
    value: 150,
    suffix: 'M+',
    prefix: '$',
    label: 'Production from Hired Reps',
    sublabel: ''
  }, {
    icon: TrendingUpIcon,
    value: 45,
    suffix: '%',
    label: 'Better Retention',
    sublabel: ''
  }, {
    icon: CheckCircleIcon,
    value: 85,
    suffix: '%',
    prefix: '+',
    label: 'Client Retention',
    sublabel: ''
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <section className="section-padding bg-gray-50" data-id="element-927">
      <div className="container-custom" data-id="element-928">
        <div className="max-w-5xl mx-auto" data-id="element-929">
          <motion.div className="text-center mb-12 md:mb-16" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5
        }} data-id="element-930">
            <h2 className="mb-4" data-id="element-931">Proven Results Across Markets</h2>
          </motion.div>

          <motion.div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-932">
            {metrics.map((metric, index) => {
            const Icon = metric.icon;
            return <motion.div key={index} className="bg-white rounded-xl p-6 md:p-8 shadow-lg border-2 border-gray-200 text-center" variants={itemVariants} data-id="element-933">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-slate/10 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-934">
                    <Icon className="h-6 w-6 md:h-7 md:w-7 text-slate" data-id="element-935" />
                  </div>
                  <div className="text-3xl md:text-4xl font-bold text-deep-blue mb-2" data-id="element-936">
                    <AnimatedMetric value={metric.value} prefix={metric.prefix} suffix={metric.suffix} duration={2000} data-id="element-937" />
                  </div>
                  <p className="font-semibold mb-1" data-id="element-938">{metric.label}</p>
                  <p className="text-xs text-gray-600" data-id="element-939">{metric.sublabel}</p>
                </motion.div>;
          })}
          </motion.div>
        </div>
      </div>
    </section>;
}